<template>
  <div
    class="checkbox-container"
    :class="{ 'three-column': hasMultipleColumns }"
  >
    <template v-for="option in options">
      <VCheckbox
        :key="option.value"
        :field-value="fieldValue(option)"
        @input="(value) => handleInput(value, option)"
        :label="option.text"
        :name="name + '-' + option.value"
      />
    </template>
  </div>
</template>
<script>
import VCheckbox from "./VCheckbox.vue";

export default {
  name: "VCheckboxGroup",
  components: { VCheckbox },
  props: {
    columns: {
      type: Number,
      default: 1,
    },
    cy: {
      type: String,
      required: false,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedValues() {
      return this.selected
        ? this.selected.map((selection) => {
            // some selections are objects like { ..., value: "val" }
            if (
              typeof selection === "object" &&
              selection !== null &&
              selection.hasOwnProperty("value")
            ) {
              return selection.value;
            }

            return selection;
          })
        : [];
    },
    hasMultipleColumns() {
      return this.columns > 1;
    },
  },
  methods: {
    fieldValue(option) {
      return this.selectedValues?.includes(option.value) || false;
    },
    handleInput(value, option) {
      let newMultiSelectValue = this.selectedValues || [];
      if (value) {
        newMultiSelectValue = [...newMultiSelectValue, option.value];
      } else {
        newMultiSelectValue = newMultiSelectValue.filter(
          (item) => item !== option.value,
        );
      }
      this.$emit("change", newMultiSelectValue);
    },
  },
};
</script>

<style scoped>
:root {
  --disabled-text: #757575;
  --primary-light: #5f6a78;
  --primary-dark: #253446;
}

.checkbox-container {
  display: grid;
  grid-template-columns: 1fr;
}

.checkbox-container.three-column {
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
